import JWT from 'jsonwebtoken'

import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '@/store/actions/user'
import { AUTH_LOGOUT } from '@/store/actions/auth'

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  isAdmin: state => state.profile.roles ? state.profile.roles.includes('admin') : false
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}, token) => {
    commit(USER_REQUEST)
    var userProfile
    if (process.vars.AUTH_FAKE_AUTH) {
      userProfile = { roles: [process.vars.AUTH_FAKE_ROLES],
        name: process.vars.AUTH_FAKE_ROLES,
        email: process.vars.AUTH_FAKE_ROLES + '@example.com' }
    } else {
      try {
        userProfile = JWT.verify(token)
      } catch (err) {
        return dispatch(USER_ERROR)
      }
    }
    commit(USER_SUCCESS, userProfile)
  },
  [USER_ERROR]: ({commit, dispatch}) => {
    commit(USER_ERROR)
    commit(AUTH_LOGOUT)
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, userProfile) => {
    state.status = 'success'
    state.profile = userProfile
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
